export default {
  SET_CALENDAR: 'tournament/SET_CALENDAR',
  SET_TOURNAMENTS: 'tournament/SET_TOURNAMENTS',
  gql: {
    GET_CALENDAR: `
      query(
        $to: String!
        $from: String!
        $golfId: String!
      ) {
        getTournamentsCalendar(
          to: $to
          from: $from
          golfId: $golfId
        ) {
          id
          name
          lifecycle
          startDate
          updatedAt
          gameFormula
          numberOfRounds
          registration {
            open
            openOnline
            endAt
            limit
            counter
            endTime
            startAt
            partnerAllowed
            isMemberOnly
          }
          informations
        }
      }
    `,
    GET_TOURNAMENT: `
      query(
        $id: String!
        $golfId: String!
      ) {
        getTournament(
          id: $id
          golfId: $golfId
        ) {
          id
          name
          lifecycle
          startDate
          updatedAt
          gameFormula
          informations
          showEntryList
          isTeamFormat
          numberOfRounds
          cancelableUntil
          shotgun
          slots {
            id
            name
            availability
          }
          registration {
            open
            openOnline
            endAt
            limit
            counter
            endTime
            startAt
            partnerAllowed
            isMemberOnly
          }
          paymentMethods
        }
      }
    `,
    GET_RESULTS: `
      query(
        $id: String!
        $type: String!
        $golfId: String!
      ) {
        getTournamentResults(
          id: $id
          type: $type
          golfId: $golfId
        ) {
          rank
          club
          hcp
          lastName
          firstName
          nationality
          result
          status
          serieName
          numberOfRounds
          tournamentType
          series # deprecated
          lastname # deprecated
          firstname # deprecated
          licenseNumber
          scorecard {
            rank
            par
            scores
            totalPar
            totalScore
            result
            status
            hasIncompleteHole
          }
        }
      }
    `,
    GET_STARTLIST: `
      query(
        $id: String!
        $golfId: String!
      ) {
        getTournamentStartList(
          id: $id
          golfId: $golfId
        ) {
          time
          players {
            hcp
            series
            lastname
            startTee
            firstname
            startHole
            nationality
            licenseNumber
            startTeeColor
          }
        }
      }
    `,
    GET_ENTRY_LIST: `
      query(
        $id: String!
        $golfId: String!
      ) {
        getTournamentEntryList(
          id: $id
          golfId: $golfId
        ) {
          name
          slot {
            id
            name
          }
          email
          owner
          partners
          createdAt
          reference
          licenseNumber
          teamNumber
        }
      }
    `,
    GET_MY_TOURNAMENTS: `
      query(
        $golfId: String
      ) {
        getMyTournaments(
          golfId: $golfId
        ) {
          id
          name
          ffgId
          status
          startAt
          nbEntrants
          gameFormula
          registeredAt
        }
      }
    `,
  },
};
